import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CatelogueItem.css';
import { faListCheck } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import QuizModal from './Modals/QuizModal';

function Quiz() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CIT NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CIT_A1">
          <FontAwesomeIcon icon={faListCheck} />
        </div>
        <div className="CIT_A2">
          Quiz
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <QuizModal />
      </Modal>
    </div>
  );
}

export default Quiz;
